import styled from 'styled-components';
import styledNative from 'styled-components/native';
import {
    TableCell,
    TableRow,
    TableContainer,
    InputBase,
    Pagination
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import { TextInput, Text as TextNative } from 'react-native';

export const StyledTableCell = muiStyled(TableCell)(({ theme }) => ({
    padding: '12px 16px',
    '&.MuiTableCell-head': {
        backgroundColor: '#4363ff',
        color: theme.palette.common.white,
        border: 'none',
        fontWeight: 600,
        fontSize: '14px'
    },
    '&.MuiTableCell-body': {
        color: theme.palette.text.primary,
        border: 'none',
        fontSize: '14px'
    }
}));

export const StyledTableRow = muiStyled(TableRow)(({ theme }) => ({
    height: '40px',
    '&:nth-of-type(odd)': {
        backgroundColor: '#f5f5f5'
    },
    '&:nth-of-type(even)': {
        backgroundColor: theme.palette.background.paper
    },
    '&:hover': {
        backgroundColor: theme.palette.action.hover
    }
}));

export const StyledTableContainer = muiStyled(TableContainer)(() => ({
    height: '70%',
    width: '100%',
    boxShadow: 'rgba(149, 157, 165, 0.05) 0px 8px 24px',
    marginTop: 10
}));

export const SelectInput = muiStyled(InputBase)(({ theme }) => ({
    height: 31,
    borderRadius: 5,
    border: '1px solid grey',
    fontSize: 16,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '& .MuiInputBase-input': {
        padding: '4px 8px'
    },
    '&.Mui-focused': {
        border: '2px solid #085ccc'
    }
}));

export const StyledPagination = muiStyled(Pagination)(() => ({
    marginTop: 25
}));

export const Text = styledNative(TextNative)`
  font-family: NunitoSans-Regular;
  font-size: 1.6rem;
  margin: 0;
    color: inherit;
`;

export const OptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
`;

export const SearchContainer = styled.div`
    width: 50%;
    padding-right: 10px;
`;

export const SelectContainer = styled.div`
    float: right;
    width: 100px;
    padding-right: 10px;
`;

export const UsuariosContainer = styled.div`
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 32px 100px 0 25px;
    width: 95%;
    height: 80%;
`;

export const ButtonHeaderContainer = styled.div`
    display: flex;
    margin-left: auto;
    max-width: 230px;
    padding-right: 50px;
    align-items: center;
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-self: flex-start;
    max-width: 230px;
    margin-top: 20px;
`;

export const TextInputNative = styledNative(TextInput)`
  border: 1px solid grey;
  border-radius: 5px;
  height: 30px;
  padding-left: 5px;
  margin-top: 10px;
`;

export const ErrorContainer = styled.div`
    width: 100%;
    text-align: end;
    margin-top: 10px;
`;

export const ErrorText = styled.span`
    font-family: NunitoSans-Regular;
    font-size: 1.2rem;
    color: red;
    text-align: end;
`;

export const Footer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
`;

export const PaginationContainer = styled.div`
    width: auto;
    margin-left: auto;
`;
